<template>
    <div>
        <div class="option-title" v-if='!showPlaneMode'>Fretes e Entregas</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Fretes e Entregas</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">Como o frete é calculado?</p>
                <p>
                    Tanto prazo de entrega quanto valor de frete variam de acordo com o método de
                    entrega escolhido por cada cliente.
                </p>
                <p>
                    Para saber o prazo de entrega de um pedido e calcular o frete, basta adicionar
                    os produtos desejados à sacola de compras e inserir o CEP no campo
                    correspondente.
                </p>
                <p>
                    As modalidades disponíveis para o endereço serão exibidas junto do valor e do
                    prazo de entrega, que é um intervalo de datas (podendo ser entregue até o último
                    dia informado). No check-out, basta selecionar a modalidade de sua preferência.
                </p>
            </li>

            <li>
                <p class="option-subtitle">É possível ter frete grátis em alguma compra?</p>
                <p>Não.</p>
            </li>

            <li>
                <p class="option-subtitle">Quem paga o frete?</p>
                <p>
                    O cliente é sempre responsável pelo pagamento do frete durante o check-out. Os
                    valores podem ser consultados na sacola de compras.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Qual é o tempo de entrega do pedido?</p>
                <p>
                    O prazo de entrega não é fixo e deve ser calculado adicionando cada produto
                    desejado na sacola de compras. O cliente é informado sobre o mesmo no momento em
                    que fornece o seu CEP.
                    <strong>
                        O tempo para produção de cada produto já está computado nesse
                        cálculo.</strong
                    >
                </p>
            </li>

            <li>
                <p class="option-subtitle">Em nome de quem vai a Nota Fiscal do pedido?</p>
                <p>
                    A NF vai em nome de
                    <strong>CR MINAS COMÉRCIO ELETRÔNICO EIRELI EPP</strong>, CNPJ
                    <strong>09.148.763/0001-59</strong>.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CarrierTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
